import { useCustomCursor } from "@/hooks/useCustomCursor";

export default function CustomCursor() {
  const { enabled, dotRef, haloRef } = useCustomCursor();
  if (!enabled) return null;

  return (
    <>
      <div ref={haloRef} className="custom-cursor-halo" data-theme="dark" aria-hidden="true" />
      <div ref={dotRef} className="custom-cursor-dot" data-theme="dark" aria-hidden="true" />
    </>
  );
}
